<app-page>
    <div class="top-cta">
      <dx-button
        [text]="'COMMON.BACK' | translate"
        icon="back"
        type="default"
        class="integration-btn"
        (click)="navigateBack()"
      >
      </dx-button>
      <dx-button
        class="cta-btn"
        type="normal"
        text="{{ 'COMMON.SAVE' | translate }}"
        (click)="submit()"
      ></dx-button>
    </div>
    <app-page-title
      [title]="
        editingMode
          ? ('COMPLIANCE.OVERVIEW.EDIT-TITLE' | translate)
          : ('COMPLIANCE.OVERVIEW.ADD-TITLE' | translate)
      "
    ></app-page-title>
    <div class="row">
      <div class="col-md-12 col-lg-5">
        <app-panel class="image-panel">
          <div id="avatar-upload" class="uploader-container">
            <img
              class="category-image"
              [src]="formData.image"
              *ngIf="formData.image"
            />
            <img
              class="category-image"
              src=""
              appTrainingImageFallback
              *ngIf="!formData.image && editingMode"
            />
            <div
              class="uploader-preview-container"
              *ngIf="!formData.image && !editingMode"
            >
              <img src="assets/img/upload.jpg" />
              <span class="preview-title">{{
                "COMMON.UPLOAD-IMAGE" | translate
              }}</span>
              <span class="preview-description">{{
                "COMMON.UPLOAD-IMAGE-SIZE" | translate
              }}</span>
            </div>
          </div>
          <dx-file-uploader
            #fileUploader
            dialogTrigger="#avatar-upload"
            dropZone="#avatar-upload"
            [multiple]="false"
            [allowedFileExtensions]="['.jpg', '.jpeg', '.gif', '.png']"
            uploadMode="useForm"
            [visible]="false"
            (valueChange)="onCategoryImageSelected($event)"
          ></dx-file-uploader>
        </app-panel>
      </div>
      <div class="col-md-12 col-lg-7">
        <app-panel
          class="training-category-panel"
          [title]="'ADMINISTRATION.TITLE-DESCRIPTION' | translate"
        >
          <dx-form #descriptionForm labelMode="floating" [formData]="formData">
            <dxi-item dataField="name">
              <dxo-label [text]="'COMMON.FIELDS.NAME' | translate"></dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.NAME-REQUIRED' | translate"
              ></dxi-validation-rule>
            </dxi-item>
            <dxi-item
              dataField="description"
              editorType="dxTextArea"
              [editorOptions]="{
                height: 145
              }"
            >
              <dxo-label
                [text]="'COMMON.FIELDS.DESCRIPTION' | translate"
              ></dxo-label>
            </dxi-item>
          </dx-form>
        </app-panel>
      </div>
      <div class="col-md-12">
        <app-panel [title]="'ADMINISTRATION.EXTENDED-DESCRIPTION' | translate">
          <app-expandable-text-editor
            *ngIf="formData"
            [(value)]="formData.descriptionExtended"
          ></app-expandable-text-editor>
          <div 
            *ngIf="userContext.canUseTextTemplates"
            class="text-template-container"
          >
            <app-text-template-selector
              [type]="descriptionTextTemplateType"
              [content]="formData.descriptionExtended"
              (contentChange)="onTemplateContentChanged($event)"
            ></app-text-template-selector>
          </div>
        </app-panel>
      </div>
    </div>
    @if(editingMode && currentComplianceCategory) {
      <div>
        <app-page *ngIf="currentComplianceCategory.assignedCourse">
          <div class="row flex-wrap">
            <div class="col-12 col-md-6" *ngIf="complianceIddProgress">
              <app-panel class="h-100"
                [title]="'COMPLIANCE.COMMON.COMPLIANCE-LEVEL' | translate"
              >
                <app-compliance-competence-matrix
                  [complianceIddProgress]="complianceIddProgress">
                </app-compliance-competence-matrix>
              </app-panel>
            </div>

            <div class="col-12 col-md-6" *ngIf="complianceLocationIddProgress">
              <app-panel class="h-100"
                [title]="'COMPLIANCE.COMMON.LOCATION-QUALIFICATION-STATUS' | translate"
              >
                <app-compliance-location-qualification-status
                  [complianceLocationIddProgress]="complianceLocationIddProgress">
                </app-compliance-location-qualification-status>
              </app-panel>
            </div>
          </div>
        </app-page>
        <app-page *ngIf="associatedCourses">
          <app-page-title
              [title]="'COMPLIANCE.COMMON.ASSOCIATED-COURSES' | translate"
          ></app-page-title>
          <app-compliance-associated-courses
            [complianceId]="currentComplianceCategory.complianceCategory.id"
            [renewalFrequency]="currentComplianceCategory.complianceCategory.renewalFrequency"
            [associatedCourses]="associatedCourses"
            (createCourse)="onCreateCourse()"
            (courseClick)="onCourseClick($event)"
          ></app-compliance-associated-courses>         
        </app-page>
      </div>
    }
    <div>
      <app-panel [title]="'COMPLIANCE.FORM.COMPLIANCE-SETTINGS' | translate">
        <dx-form
          #settingsForm
          labelMode="floating"
          [showColonAfterLabel]="false"
          [formData]="formData"
        >
          <dxi-item itemType="group">
            <dxo-col-count-by-screen
              [xs]="1"
              [sm]="1"
              [md]="1"
              [lg]="2"
            ></dxo-col-count-by-screen>
            <dxi-item
              itemType="group"
              [caption]="'COMPLIANCE.FORM.GENERAL-SETTINGS' | translate"
            >
              <dxi-item
                [editorOptions]="renewalFrequencyOptions"
                dataField="renewalFrequency"
                editorType="dxSelectBox"
              >
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.RENEWAL-FREQUENCY-REQUIRED' | translate"
                ></dxi-validation-rule>
                <dxo-label
                  [text]="'COMMON.FIELDS.RENEWAL-FREQUENCY' | translate"
                ></dxo-label>
              </dxi-item>
              <dxi-item
                dataField="reminderDays"
                editorType="dxNumberBox"
                [editorOptions]="{
                  onValueChanged: onReminderDaysChanged.bind(this)
                }"
              >
                <dxo-label
                  [text]="'COMPLIANCE.FIELDS.REMINDER-DAYS' | translate"
                ></dxo-label>
                <dxi-validation-rule
                  type="required"
                  [message]="'COMPLIANCE.VALIDATIONS.REMINDERS-REQUIRED' | translate"
                ></dxi-validation-rule>
                <dxi-validation-rule 
                  type="range" 
                  [min]="0" 
                  [message]="'COMPLIANCE.VALIDATIONS.REMINDERS-CANNOT-BE-NEGATIVE' | translate" 
                ></dxi-validation-rule>
              </dxi-item>
              <dxi-item
                dataField="escalationReminder"
                editorType="dxCheckBox"
                [editorOptions]="{
                  text: 'COMPLIANCE.FIELDS.ESCALATION-REMINDER' | translate,
                  disabled: !formData.reminderDays,
                  onValueChanged: onEscalationReminderChanged.bind(this)
                }"
              >
                <dxo-label [visible]="false"> </dxo-label>
              </dxi-item>
              @if(formData.escalationReminder) {
                <dxi-item
                  [editorOptions]="escalationReminderDaysOptions"
                  dataField="escalationReminderNumber"
                  editorType="dxSelectBox"
                >
                  <dxi-validation-rule
                    type="required"
                    [message]="'COMPLIANCE.VALIDATIONS.ESCALATION-REMINDER-NUMBER-REQUIRED' | translate"
                  ></dxi-validation-rule>
                  <dxo-label
                    [text]="'COMPLIANCE.FIELDS.ESCALATION-REMINDER-NUMBER' | translate"
                  ></dxo-label>
                </dxi-item>
                <dxi-item
                  dataField="escalationReminderDays"
                  editorType="dxNumberBox"
                >
                  <dxo-label
                    [text]="'COMPLIANCE.FIELDS.ESCALATION-REMINDER-DAYS' | translate"
                  ></dxo-label>
                  <dxi-validation-rule
                    type="required"
                    [message]="'COMPLIANCE.VALIDATIONS.REMINDERS-REQUIRED' | translate"
                  ></dxi-validation-rule>
                  <dxi-validation-rule 
                    type="range" 
                    [min]="1" 
                    [message]="'COMPLIANCE.VALIDATIONS.REMINDERS-MUST-HAVE-VALUE' | translate" 
                  ></dxi-validation-rule>
                </dxi-item>
              }
              <dxi-item
                [editorOptions]="reminderDaysUntilSupervisorOptions"
                dataField="remindersUntilSupervisorInfo"
                editorType="dxSelectBox"
              >
               <dxi-validation-rule
                  type="required"
                  [message]="'COMPLIANCE.VALIDATIONS.REMINDERS-UNTIL-SUPERVISOR-REQUIRED' | translate"
                ></dxi-validation-rule>
                <dxo-label
                  [text]="'COMPLIANCE.FIELDS.REMINDERS-UNTIL-SUPERVISOR' | translate"
                ></dxo-label>
              </dxi-item>
              @if(!isNeverRenewalFrequency) {
                <dxi-item
                  dataField="reassignBeforeExpiry"
                  editorType="dxCheckBox"
                  [editorOptions]="{
                    text: 'COMPLIANCE.FIELDS.REASSIGN-BEFORE-EXPIRY' | translate,
                  }"
                >
                  <dxo-label [visible]="false"></dxo-label>
                </dxi-item>
              }
              <dxi-item>
                <dxo-label
                  [text]="'COMPLIANCE.FIELDS.SUPERADMIN-PERSONS' | translate"
                ></dxo-label>
                <div *dxTemplate>
                  <dx-drop-down-box
                    [(value)]="formData.superAdminPersonIds"
                    valueExpr="id"
                    displayExpr="name"
                    [label]="'COMPLIANCE.FIELDS.SUPERADMIN-PERSONS' | translate"
                    [dataSource]="persons"
                    labelMode="floating"
                    stylingMode="outlined"
                  >
                    <div *dxTemplate="let data of 'content'">
                      <dx-tree-view
                        [searchEnabled]="true"
                        [dataSource]="persons"
                        dataStructure="plain"
                        keyExpr="id"
                        selectionMode="multiple"
                        showCheckBoxesMode="normal"
                        [selectNodesRecursive]="false"
                        displayExpr="name"
                        [selectByClick]="true"
                        (onItemSelectionChanged)="onSuperAdminPersonSelected($event)"
                      >
                      </dx-tree-view>
                    </div>
                  </dx-drop-down-box>
                </div>
              </dxi-item>
            </dxi-item>
            <dxi-item itemType="group">
              <dxi-item>
                <div *dxTemplate>
                  <app-target-group-section
                    [isViewMode]="false"
                    [isCourse]="true"
                    [(visibilityMode)]="visibilityMode"

                    [(selectedOrganizationUnitIds)]="selectedOrganizationUnitIds"
                    [(trainingGroupIds)]="formData.trainingGroupIds"
                    [(trainingCategoryIds)]="formData.trainingCategoryIds"

                    [organizationUnits]="organizationUnits"
                    [trainingGroups]="trainingGroups"
                    [trainingCategories]="trainingCategories"
                    [personCount]="personCount"
                  ></app-target-group-section>
                </div>
              </dxi-item>
              <dxi-item>
                <dxo-label
                  [text]="'COMMON.FIELDS.LEARNING-PATHS' | translate"
                ></dxo-label>
                <div *dxTemplate>
                  <hr>
                  <dx-drop-down-box
                    [(value)]="formData.learningPathIds"
                    [inputAttr]="{ 'aria-label': 'Owner' }"
                    valueExpr="id"
                    displayExpr="name"
                    [label]="'COMMON.FIELDS.LEARNING-PATHS' | translate"
                    [dataSource]="learningPaths"
                    labelMode="floating"
                    stylingMode="outlined"
                  >
                    <div *dxTemplate="let data of 'content'">
                      <dx-tree-view
                        [searchEnabled]="true"
                        [dataSource]="learningPaths"
                        dataStructure="plain"
                        keyExpr="id"
                        selectionMode="multiple"
                        showCheckBoxesMode="normal"
                        [selectNodesRecursive]="false"
                        displayExpr="name"
                        [selectByClick]="true"
                        (onItemSelectionChanged)="
                          onLearningPathSelected($event)
                        "
                      >
                      </dx-tree-view>
                    </div>
                  </dx-drop-down-box>
                </div>
              </dxi-item>
            </dxi-item>
          </dxi-item>
        </dx-form>
      </app-panel>
    </div>
</app-page>

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showUnsavedChangesModal"
  (submit)="onUnsavedChangesConfirmed()"
  [options]="unsavedChangesModalOptions"
></app-confirmation-dialog>